import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _a2b4d842 = () => interopDefault(import('../src/pages/companies/index.vue' /* webpackChunkName: "pages/companies/index" */))
const _ee807f4e = () => interopDefault(import('../src/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _3693c0b0 = () => interopDefault(import('../src/pages/sign_in.vue' /* webpackChunkName: "pages/sign_in" */))
const _12f76c71 = () => interopDefault(import('../src/pages/google-calendar/callback.vue' /* webpackChunkName: "pages/google-calendar/callback" */))
const _63235a36 = () => interopDefault(import('../src/pages/initial-settings/company-profile.vue' /* webpackChunkName: "pages/initial-settings/company-profile" */))
const _c386690e = () => interopDefault(import('../src/pages/initial-settings/invite-members.vue' /* webpackChunkName: "pages/initial-settings/invite-members" */))
const _55f37e6a = () => interopDefault(import('../src/pages/initial-settings/user-profile.vue' /* webpackChunkName: "pages/initial-settings/user-profile" */))
const _21354192 = () => interopDefault(import('../src/pages/sessions/branu-logout.vue' /* webpackChunkName: "pages/sessions/branu-logout" */))
const _b83c6a10 = () => interopDefault(import('../src/pages/sessions/callback.vue' /* webpackChunkName: "pages/sessions/callback" */))
const _01dfbb1c = () => interopDefault(import('../src/pages/sessions/callback-with-branu-user.vue' /* webpackChunkName: "pages/sessions/callback-with-branu-user" */))
const _40631d8c = () => interopDefault(import('../src/pages/sessions/invitation.vue' /* webpackChunkName: "pages/sessions/invitation" */))
const _c8e6c192 = () => interopDefault(import('../src/pages/contents/_uuid/index.vue' /* webpackChunkName: "pages/contents/_uuid/index" */))
const _259f9790 = () => interopDefault(import('../src/pages/companies/_company_id/attendance-summary.vue' /* webpackChunkName: "pages/companies/_company_id/attendance-summary" */))
const _3c514259 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds" */))
const _0d86df2c = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds/new.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds/new" */))
const _12590ccf = () => interopDefault(import('../src/pages/companies/_company_id/customers.vue' /* webpackChunkName: "pages/companies/_company_id/customers" */))
const _ce63a040 = () => interopDefault(import('../src/pages/companies/_company_id/customers/new.vue' /* webpackChunkName: "pages/companies/_company_id/customers/new" */))
const _008f3dfd = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/index" */))
const _60feb1af = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/edit" */))
const _6b7709a5 = () => interopDefault(import('../src/pages/companies/_company_id/expiration.vue' /* webpackChunkName: "pages/companies/_company_id/expiration" */))
const _35ca0813 = () => interopDefault(import('../src/pages/companies/_company_id/members.vue' /* webpackChunkName: "pages/companies/_company_id/members" */))
const _2651feba = () => interopDefault(import('../src/pages/companies/_company_id/profile.vue' /* webpackChunkName: "pages/companies/_company_id/profile" */))
const _be7b4d20 = () => interopDefault(import('../src/pages/companies/_company_id/projects.vue' /* webpackChunkName: "pages/companies/_company_id/projects" */))
const _6b3be81a = () => interopDefault(import('../src/pages/companies/_company_id/projects/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/index" */))
const _61fe9cad = () => interopDefault(import('../src/pages/companies/_company_id/projects/calendar.vue' /* webpackChunkName: "pages/companies/_company_id/projects/calendar" */))
const _e7f213ee = () => interopDefault(import('../src/pages/companies/_company_id/projects/gantt-chart/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/gantt-chart/index" */))
const _028e4401 = () => interopDefault(import('../src/pages/companies/_company_id/projects/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/new" */))
const _4cef8363 = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/index" */))
const _56224d5c = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/devices-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/devices-allocation/index" */))
const _4c343607 = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/member-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/member-allocation/index" */))
const _224f21ca = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id" */))
const _2ec41544 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/index" */))
const _b082f160 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/index" */))
const _e566966e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/index" */))
const _49349892 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/card/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/card/index" */))
const _79187416 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/detail.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/detail" */))
const _356d5060 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/ledger/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/ledger/index" */))
const _9d702884 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/member.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/member" */))
const _254ff50e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/index" */))
const _5f01a87e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/index" */))
const _5a00daa4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/summary.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/summary" */))
const _631211de = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-list.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-list" */))
const _4293f132 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-records.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-records" */))
const _430b8736 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils" */))
const _423e0f76 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils/user-list.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils/user-list" */))
const _1c992a57 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/new" */))
const _83f9f366 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/posts/index" */))
const _e6704524 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/select-daily-reports.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/select-daily-reports" */))
const _d8e80182 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/fullscreen" */))
const _4723c374 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/preview" */))
const _24f38c9c = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/print/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/print/index" */))
const _7576fdec = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/index" */))
const _05d8de91 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/fullscreen" */))
const _cdfcc526 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/index" */))
const _50bfbafe = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/index" */))
const _2beab782 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/edit" */))
const _15b5b4d6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index" */))
const _0f8bdee4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/edit" */))
const _7cb19418 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/preview" */))
const _facf7cf0 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/form.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/form" */))
const _55806eb4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/preview" */))
const _a38f3508 = () => interopDefault(import('../src/pages/companies/_company_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/index" */))
const _4a124c6c = () => interopDefault(import('../src/pages/companies/_company_id/setting.vue' /* webpackChunkName: "pages/companies/_company_id/setting" */))
const _022b7db8 = () => interopDefault(import('../src/pages/companies/_company_id/sharing-contents/index.vue' /* webpackChunkName: "pages/companies/_company_id/sharing-contents/index" */))
const _66dfe6cb = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/index" */))
const _d43d882c = () => interopDefault(import('../src/pages/companies/_company_id/unavailability.vue' /* webpackChunkName: "pages/companies/_company_id/unavailability" */))
const _60a3611d = () => interopDefault(import('../src/pages/companies/_company_id/user-profile.vue' /* webpackChunkName: "pages/companies/_company_id/user-profile" */))
const _34e4d242 = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/analytics/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/analytics/index" */))
const _97654cc2 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/index" */))
const _41ab3b32 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/index" */))
const _3b462b8a = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/_member_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/_member_id/index" */))
const _9dc4cc66 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/edit" */))
const _7847b055 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/preview" */))
const _c45b35d4 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/ai_pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/ai_pdf" */))
const _15985805 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/edit" */))
const _35c9b5c7 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/pdf" */))
const _22ea5f5b = () => interopDefault(import('../src/pages/companies/_company_id/project/_id/schedule/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/project/_id/schedule/pdf" */))
const _76af5b5a = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'

    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto'
    })

    // Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual'
    })
  }
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected and scrollToTop is not explicitly disabled
  if (
    to.matched.length < 2 &&
    to.matched.every(r => r.components.default.options.scrollToTop !== false)
  ) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise((resolve) => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/companies",
      component: _a2b4d842,
      name: "companies"
    }, {
      path: "/logout",
      component: _ee807f4e,
      name: "logout"
    }, {
      path: "/sign_in",
      component: _3693c0b0,
      name: "sign_in"
    }, {
      path: "/google-calendar/callback",
      component: _12f76c71,
      name: "google-calendar-callback"
    }, {
      path: "/initial-settings/company-profile",
      component: _63235a36,
      name: "initial-settings-company-profile"
    }, {
      path: "/initial-settings/invite-members",
      component: _c386690e,
      name: "initial-settings-invite-members"
    }, {
      path: "/initial-settings/user-profile",
      component: _55f37e6a,
      name: "initial-settings-user-profile"
    }, {
      path: "/sessions/branu-logout",
      component: _21354192,
      name: "sessions-branu-logout"
    }, {
      path: "/sessions/callback",
      component: _b83c6a10,
      name: "sessions-callback"
    }, {
      path: "/sessions/callback-with-branu-user",
      component: _01dfbb1c,
      name: "sessions-callback-with-branu-user"
    }, {
      path: "/sessions/invitation",
      component: _40631d8c,
      name: "sessions-invitation"
    }, {
      path: "/contents/:uuid?",
      component: _c8e6c192,
      name: "contents-uuid"
    }, {
      path: "/companies/:company_id/attendance-summary",
      component: _259f9790,
      name: "companies-company_id-attendance-summary"
    }, {
      path: "/companies/:company_id/construction-kinds",
      component: _3c514259,
      name: "companies-company_id-construction-kinds",
      children: [{
        path: "new",
        component: _0d86df2c,
        name: "companies-company_id-construction-kinds-new"
      }]
    }, {
      path: "/companies/:company_id/customers",
      component: _12590ccf,
      name: "companies-company_id-customers",
      children: [{
        path: "new",
        component: _ce63a040,
        name: "companies-company_id-customers-new"
      }, {
        path: ":id",
        component: _008f3dfd,
        name: "companies-company_id-customers-id"
      }, {
        path: ":id/edit",
        component: _60feb1af,
        name: "companies-company_id-customers-id-edit"
      }]
    }, {
      path: "/companies/:company_id/expiration",
      component: _6b7709a5,
      name: "companies-company_id-expiration"
    }, {
      path: "/companies/:company_id/members",
      component: _35ca0813,
      name: "companies-company_id-members"
    }, {
      path: "/companies/:company_id/profile",
      component: _2651feba,
      name: "companies-company_id-profile"
    }, {
      path: "/companies/:company_id/projects",
      component: _be7b4d20,
      children: [{
        path: "",
        component: _6b3be81a,
        name: "companies-company_id-projects"
      }, {
        path: "calendar",
        component: _61fe9cad,
        name: "companies-company_id-projects-calendar"
      }, {
        path: "gantt-chart",
        component: _e7f213ee,
        name: "companies-company_id-projects-gantt-chart"
      }, {
        path: "new",
        component: _028e4401,
        name: "companies-company_id-projects-new"
      }, {
        path: "resource-allocation",
        component: _4cef8363,
        name: "companies-company_id-projects-resource-allocation"
      }, {
        path: "resource-allocation/devices-allocation",
        component: _56224d5c,
        name: "companies-company_id-projects-resource-allocation-devices-allocation"
      }, {
        path: "resource-allocation/member-allocation",
        component: _4c343607,
        name: "companies-company_id-projects-resource-allocation-member-allocation"
      }, {
        path: ":id",
        component: _224f21ca,
        children: [{
          path: "",
          component: _2ec41544,
          name: "companies-company_id-projects-id"
        }, {
          path: "attendance",
          component: _b082f160,
          name: "companies-company_id-projects-id-attendance"
        }, {
          path: "board_posts",
          component: _e566966e,
          name: "companies-company_id-projects-id-board_posts"
        }, {
          path: "card",
          component: _49349892,
          name: "companies-company_id-projects-id-card"
        }, {
          path: "detail",
          component: _79187416,
          name: "companies-company_id-projects-id-detail"
        }, {
          path: "ledger",
          component: _356d5060,
          name: "companies-company_id-projects-id-ledger"
        }, {
          path: "member",
          component: _9d702884,
          name: "companies-company_id-projects-id-member"
        }, {
          path: "reports",
          component: _254ff50e,
          name: "companies-company_id-projects-id-reports"
        }, {
          path: "schedule",
          component: _5f01a87e,
          name: "companies-company_id-projects-id-schedule"
        }, {
          path: "attendance/summary",
          component: _5a00daa4,
          name: "companies-company_id-projects-id-attendance-summary"
        }, {
          path: "attendance/user-list",
          component: _631211de,
          name: "companies-company_id-projects-id-attendance-user-list"
        }, {
          path: "attendance/user-records",
          component: _4293f132,
          name: "companies-company_id-projects-id-attendance-user-records"
        }, {
          path: "attendance/utils",
          component: _430b8736,
          name: "companies-company_id-projects-id-attendance-utils",
          children: [{
            path: "user-list",
            component: _423e0f76,
            name: "companies-company_id-projects-id-attendance-utils-user-list"
          }]
        }, {
          path: "board_posts/new",
          component: _1c992a57,
          name: "companies-company_id-projects-id-board_posts-new"
        }, {
          path: "board_posts/posts",
          component: _83f9f366,
          name: "companies-company_id-projects-id-board_posts-posts"
        }, {
          path: "reports/select-daily-reports",
          component: _e6704524,
          name: "companies-company_id-projects-id-reports-select-daily-reports"
        }, {
          path: "schedule/fullscreen",
          component: _d8e80182,
          name: "companies-company_id-projects-id-schedule-fullscreen"
        }, {
          path: "schedule/preview",
          component: _4723c374,
          name: "companies-company_id-projects-id-schedule-preview"
        }, {
          path: "schedule/print",
          component: _24f38c9c,
          name: "companies-company_id-projects-id-schedule-print"
        }, {
          path: "schedule/view",
          component: _7576fdec,
          name: "companies-company_id-projects-id-schedule-view"
        }, {
          path: "schedule/view/fullscreen",
          component: _05d8de91,
          name: "companies-company_id-projects-id-schedule-view-fullscreen"
        }, {
          path: "board_posts/:board_id",
          component: _cdfcc526,
          name: "companies-company_id-projects-id-board_posts-board_id"
        }, {
          path: "files/:file_id",
          component: _50bfbafe,
          name: "companies-company_id-projects-id-files-file_id"
        }, {
          path: "board_posts/:board_id/edit",
          component: _2beab782,
          name: "companies-company_id-projects-id-board_posts-board_id-edit"
        }, {
          path: "board_posts/:board_id/files",
          component: _15b5b4d6,
          name: "companies-company_id-projects-id-board_posts-board_id-files"
        }, {
          path: "files/:file_id/edit",
          component: _0f8bdee4,
          name: "companies-company_id-projects-id-files-file_id-edit"
        }, {
          path: "files/:file_id/preview",
          component: _7cb19418,
          name: "companies-company_id-projects-id-files-file_id-preview"
        }, {
          path: "reports/:report_id/form",
          component: _facf7cf0,
          name: "companies-company_id-projects-id-reports-report_id-form"
        }, {
          path: "reports/:report_id/preview",
          component: _55806eb4,
          name: "companies-company_id-projects-id-reports-report_id-preview"
        }]
      }]
    }, {
      path: "/companies/:company_id/reports",
      component: _a38f3508,
      name: "companies-company_id-reports"
    }, {
      path: "/companies/:company_id/setting",
      component: _4a124c6c,
      name: "companies-company_id-setting"
    }, {
      path: "/companies/:company_id/sharing-contents",
      component: _022b7db8,
      name: "companies-company_id-sharing-contents"
    }, {
      path: "/companies/:company_id/skills-register",
      component: _66dfe6cb,
      name: "companies-company_id-skills-register"
    }, {
      path: "/companies/:company_id/unavailability",
      component: _d43d882c,
      name: "companies-company_id-unavailability"
    }, {
      path: "/companies/:company_id/user-profile",
      component: _60a3611d,
      name: "companies-company_id-user-profile"
    }, {
      path: "/companies/:company_id/skills-register/analytics",
      component: _34e4d242,
      name: "companies-company_id-skills-register-analytics"
    }, {
      path: "/companies/:company_id/files/:id?",
      component: _97654cc2,
      name: "companies-company_id-files-id"
    }, {
      path: "/companies/:company_id/reports/:id",
      component: _41ab3b32,
      name: "companies-company_id-reports-id"
    }, {
      path: "/companies/:company_id/skills-register/:member_id?",
      component: _3b462b8a,
      name: "companies-company_id-skills-register-member_id"
    }, {
      path: "/companies/:company_id/files/:id?/edit",
      component: _9dc4cc66,
      name: "companies-company_id-files-id-edit"
    }, {
      path: "/companies/:company_id/files/:id?/preview",
      component: _7847b055,
      name: "companies-company_id-files-id-preview"
    }, {
      path: "/companies/:company_id/reports/:id/ai_pdf",
      component: _c45b35d4,
      name: "companies-company_id-reports-id-ai_pdf"
    }, {
      path: "/companies/:company_id/reports/:id/edit",
      component: _15985805,
      name: "companies-company_id-reports-id-edit"
    }, {
      path: "/companies/:company_id/reports/:id/pdf",
      component: _35c9b5c7,
      name: "companies-company_id-reports-id-pdf"
    }, {
      path: "/companies/:company_id/project/:id?/schedule/pdf",
      component: _22ea5f5b,
      name: "companies-company_id-project-id-schedule-pdf"
    }, {
      path: "/",
      component: _76af5b5a,
      name: "index"
    }],

    fallback: false
  })
}
